import axios from 'axios';
import EventEmitter from '../Utils/EventEmitter';

export default class Manager {
    
    constructor(sdk) {
        
        this.sdk = sdk;
        
    }
    
    async saveCustom(type, id, data) {

        let body = {
            data: data
        }

        if (type == 'channel')
            body.channel = id;
        else
            body.programId = id;

        let res = await this.sdk.fetch('/custom', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json"
            }
        })

        //await Utils.sleep(300);

        return res;

    }

    async deleteCustom(type, id, data) {

        let body = {
            data: data
        }

        if (type == 'channel')
            body.channel = id;
        else
            body.programId = id;

        let res = await this.sdk.fetch('/delete/custom', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json"
            }
        })

        //await Utils.sleep(300);

        return res;

    }
    
    async getCustom(type, id) {
        return await this.sdk.fetch('/custom/' + type + '/' + id)
    }
    
    async upload(file) {
        var data = new FormData()
        data.append('file', file)

        let res = await axios
            .post(this.sdk.apiUrl + '/upload', data, {
                onUploadProgress: ProgressEvent => {
                    console.log(ProgressEvent);
                },
            })

        return res.data.file;

    }
    
}


// WEBPACK FOOTER //
// ./src/Sdk/Manager.js